export const CONTACT_PAGE_TEXT = {
    en: {
        seo: {
            title: "Contact Virtalibry – Support for KDP Tools, Publishing Workflows, and Author Growth",
            description:
                "Contact Virtalibry for help with KDP tools, publishing workflows, metadata questions, analysis utilities, account access, subscriptions, and general author support.",
            keywords:
                "contact Virtalibry, Virtalibry support, kdp tools support, amazon kdp help, publishing workflow support, metadata help, author tools support, author growth support",
            image: "https://virtalibry.com/face/why_love_is_gold_new.png",
            type: "website",

            webPage: {
                name: "Contact Virtalibry",
                url: "https://virtalibry.com/contact",
                description:
                    "Official contact page for Virtalibry. Reach out for help with KDP tools, publishing workflows, account questions, subscriptions, analysis features, and general author support.",
                datePublished: "2025-11-01T00:00:00Z",
                dateModified: "2025-11-20T00:00:00Z",
            },

            organization: {
                name: "Virtalibry",
                url: "https://virtalibry.com",
                logo: "https://virtalibry.com/logo/virtalibry_dark_free_no_bg.png",
                contactPoint: [
                    {
                        "@type": "ContactPoint",
                        contactType: "customer support",
                        email: "info@virtalibry.com",
                        availableLanguage: ["English"]
                    }
                ]
            },

            webApp: {
                type: "WebApplication",
                name: "Virtalibry KDP Tools & Growth Platform",
                url: "https://virtalibry.com",
                applicationCategory: "BusinessApplication",
                operatingSystem: "All",
                offers: {
                    price: "0",
                    priceCurrency: "USD",
                    url: "https://virtalibry.com/pricing"
                }
            },

            faq: [
                {
                    q: "What can I contact Virtalibry about?",
                    a: "You can contact Virtalibry about KDP tools, publishing workflows, metadata questions, BSR analysis, subscriptions, account issues, technical questions, and general author support."
                },
                {
                    q: "Is this contact page only for one specific feature?",
                    a: "No. Virtalibry support covers the wider publishing workflow and helps users with different platform sections, tools, and account-related questions."
                },
                {
                    q: "Who should contact Virtalibry?",
                    a: "Authors, publishers, KDP beginners, experienced self-publishers, and users exploring Virtalibry tools can all use the contact page for support and platform questions."
                },
                {
                    q: "Can I ask about metadata, tools, or analysis features?",
                    a: "Yes. You can contact Virtalibry about metadata questions, discoverability workflows, positioning ideas, BSR tools, and other publishing-related features."
                },
                {
                    q: "How quickly does Virtalibry respond?",
                    a: "Virtalibry reviews messages manually and typically replies within 12–24 hours depending on workload and the type of request."
                }
            ],

            breadcrumb: {
                homeName: "Virtalibry",
                pageName: "Contact"
            }
        },

        hero: {
            h1: "Contact Virtalibry: Help with KDP Tools, Publishing Workflows, and Author Support",
            p1:
                "Use this page to contact Virtalibry about the broader platform ecosystem, including KDP tools, publishing workflows, metadata questions, account access, subscriptions, and general author support.",

            bullets: [

            ]
        },

        blocks: {
            block1_H2: "A Central Contact Point for the Virtalibry Ecosystem",
            block1_P:
                "This page works best as the main communication entry point for users who need help understanding Virtalibry, using its tools, or solving practical account and workflow questions. It supports both trust and usability across the broader platform.",

            block2_H3: "Support Starts From a Registered Account",
            block2_P:
                "Registered users can contact support from inside their Virtalibry account, where account context, billing status, and publishing workflow details are easier to review.",

            block3_H3: "How It Fits the Brand and Tools Cluster",
            block3_P:
                "This page supports the wider Virtalibry ecosystem by giving users a clear place to ask questions about KDP tools, publishing workflows, and author-facing platform features without confusion.",

            block4_H3: "Designed for SEO and User Reassurance",
            block4_P:
                "The template version keeps the page visually consistent, preserves structured SEO data, and points users toward the correct support flow without exposing a public message form to bots.",

            block5_H3: "Use It as the Canonical Public Contact Page",
            block5_P:
                "As Virtalibry expands, this page should remain the canonical public contact page for the platform, while more specific support flows can branch into account help, pricing, tools, and workflow-specific assistance."
        }
    },
};

export const pickContactPageT = (lang) =>
    CONTACT_PAGE_TEXT?.[lang] || CONTACT_PAGE_TEXT.en;
